$(function () {
    if (!$('#translation-confirm-allocation-page').length) return false;

    $('.login-box').empty();

    let sub = getURLParameter("sub");
    let key = getURLParameter("key");
    let translator = getURLParameter("translator");
    let accept = getURLParameter("accept");
    let doc = getURLParameter("doc");

    if (sub == null || key == null || translator == null) {
        $('.login-box').append('<div class="alert alert-error">A technical error occurs : missing data</div>');
        return false;
    }
    if (doc == null && accept == null) {
        $('.login-box').append('<div class="alert alert-success">Thank you for your answer.</div>');
        return false;
    }
    $('.centered-spinner').css({ 'display': 'block' });

    // First, retrieve the file
    retrieveSub(sub, translator, key, {'accept': accept, 'doc': doc, 'translator': translator, 'sub': sub});

    $('#submit').on('click', function (e) {
        e.preventDefault();
        $('.centered-spinner').css({ 'display': 'block' });

        let form = $('#answer-translation-proposition-form');
        let formData = new FormData(form[0]);
        $.ajax({
            type: "POST",
            url: getApiURL("translations") + '/allocation/confirm',
            headers: { "Token": $.cookie('token_api') },
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function (data) {
                $('.centered-spinner').hide();
                $('.login-box').append('<div class="alert alert-success">' + data.detail + '</div>');
                // Remove the form
                $("#translation-confirm-form-block").remove();
            },
            error: function (request, textStatus, errorThrown) {
                $('.login-box').append('<div class="alert alert-error">' + parseCallbackError(request, errorThrown) + '</div>');
                $('.centered-spinner').hide();
            }
        });
    });
});

function retrieveSub(sub_id, translator, key, params) {
    $.ajax({
        type: "GET",
        url: `${getApiURL("translation_file_subdivisions")}/${sub_id}/${translator}/${key}`,
        headers: { "Token": $.cookie('token_api') },
        success: function(data) {
            if (data.file != null && params.doc == null && params.accept == 0) {
                // Specific case where no question should be asked
                makeDirectAllocation(sub_id, translator, params.accept);
                return;
            }
            populateForm(data, params);
            $("#translation-confirm-form-block").show();
            $('.centered-spinner').hide();
        },
        error: function(request, textStatus, errorThrown) {
            $('.login-box').append('<div class="alert alert-error">' + parseCallbackError(request, errorThrown) + '</div>');
            $('.centered-spinner').hide();
        }
    });
}

function makeDirectAllocation(sub_id, translator, accept) {
    $.ajax({
        type: "POST",
        url: `${getApiURL("translation_file_subdivisions")}/allocation/direct`,
        headers: { "Token": $.cookie('token_api') },
        data: {
            sub_id: sub_id,
            translator: translator,
            accept: accept
        },
        dataType: 'json',
        success: function(data) {
            $('.login-box').append('<div class="alert alert-success">' + data.detail + '</div>');     
            $('.centered-spinner').hide();
        },
        error: function(request, textStatus, errorThrown) {
            $('.login-box').append('<div class="alert alert-error">' + parseCallbackError(request, errorThrown) + '</div>');
            $('.centered-spinner').hide();
        }
    });
}

function parseCallbackError(response, defaultError) {
    if (!response.responseJSON) return defaultError;

    if ('key' in response.responseJSON) return response.responseJSON.key;
    if ('login' in response.responseJSON) return response.responseJSON.login;
    if ('fields' in response.responseJSON) return response.responseJSON.fields;
    if ('allocation' in response.responseJSON) return response.responseJSON.allocation;

    return defaultError;
}

function populateForm(data, params) {
    $('[data-translationref]').html(data.translation_ref);
    $("[name=translator]").val(params.translator);
    $("[name=check_interested]").val(params.accept);
    $("[name=sub]").val(params.sub);
    $("[name=key]").val(data.allocation_key ?? data.association_key);
    let text = '';

    // Check Doc
    if (params.doc != null) {
        text = '<tr><td colspan="3" class="proposition-question-td">Do you confirm this translation is from ' + data.file.language_from + ' to ' + data.file.language_to + ' ?</td></tr>';
		text += '<tr><td style="width:150px"></td><td class="proposition-answer-td" style="width:50px"><p class="padded-top-5"><input type="radio" id="language-yes" name="check_language" value="1" checked><label for="language-yes" class="inline-block"><span class="radio icon-inline icon-radio"></span>Yes</label></p><p class="padded-top-5"><input type="radio" id="language-no" name="check_language" value="0"><label for="language-no" class="inline-block"><span class="radio icon-inline icon-radio"></span>No</label></p></td><td></td></tr>';
        text += '<tr id="correct-languages-tr1" style="display:none"><td colspan="3" class="proposition-question-td">Please provide the correct languages :</td></tr>';
        text += '<tr id="correct-languages-tr2" style="display:none"><td></td><td class="proposition-answer-td"><p><label for="correct-languages-from" style="padding-top:13px">FROM :</label></p><br><p><label for="correct-languages-to" style="padding-top:13px">TO :</label></p></td><td><p><input type="text" name="correct_language_from" id="correct-languages-from" value="' + data.file.language_from + '"></p><br><p><input type="text" name="correct_language_to" id="correct-languages-to" value="' + data.file.language_to + '"></p></td></tr>';
        $("#answer-translation-table").append(text);
    }

    // Check Accept
    if (params.accept != null) {
        text = '<tr><td colspan="3" class="proposition-question-td">Will you be able to provide the translation before ' + formatFieldValue(data.translator_due_date, "date") + ' ?</td></tr>';
        text += '<tr><td></td><td class="proposition-answer-td"><p class="padded-top-5"><input type="radio" id="due-date-yes" name="check_due_date" value="1" checked><label for="due-date-yes" class="inline-block"><span class="radio icon-inline icon-radio"></span>Yes</label></p><p class="padded-top-5"><input type="radio" id="due-date-no" name="check_due_date" value="0"><label for="due-date-no" class="inline-block"><span class="radio icon-inline icon-radio"></span>No</label></p></td><td></td></tr>';
        text += '<tr><td colspan="3" class="proposition-question-td">Will you be able to translate the full document ?</td></tr>';
		text += '<tr><td></td><td class="proposition-answer-td" colspan="2"><p class="padded-top-5"><input type="radio" id="full-doc-yes" name="check_full_doc" value="1" checked><label for="full-doc-yes" class="inline-block"><span class="radio icon-inline icon-radio"></span>Full document</label></p><p class="padded-top-5"><input type="radio" id="full-doc-no" name="check_full_doc" value="0"><label for="full-doc-no" class="inline-block"><span class="radio icon-inline icon-radio"></span>Part of the document only</label></p></td></tr>';
        text += '<tr><td colspan="3" class="proposition-question-td">Please enter here your remarks or comments on the translation (technicity of the document, quality...) :</td></tr>';
        text += '<tr><td></td><td class="proposition-answer-td" colspan="2"><textarea name="comments" rows="5" style="width:100%"></textarea></td></tr>';
        $("#answer-translation-table").append(text);
    }
}